import { 
  Container, 
  Stack, 
  Typography, 
  Button, 
  Card, 
  TableContainer, 
  Table, 
  TableBody, 
  TableRow, 
  TableCell, 
  IconButton, 
  TablePagination, 
  Modal, 
  Box, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem,
  Grid,
  Chip,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Tooltip,
  Paper
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Iconify from '../../../layouts/Iconify';
import Scrollbar from '../../../layouts/Scrollbar';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../../layouts/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MiscSkeleton from '../../../layouts/user/MiscSkeleton';
import { GetAll, Post, apiURL } from '../../../utils/apiCalls';
import { filter } from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BadgeIcon from '@mui/icons-material/Badge';
import Label from '../../../layouts/Label';
import { capitalCase } from 'change-case';
import SearchNotFound from '../../../layouts/SearchNotFound';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'no', label: 'SNo.', align: 'left' },
    { id: 'name', label: 'Project Name', align: 'left' },
    { id: 'email', label: 'email', align: 'left' },
    { id: 'phone', label: 'phone', align: 'left' },
    { id: 'EMP ID', label: 'emp_id', align: 'left' },
    { id: '', label: '', align: 'center' },
  ];
  
  // ----------------------------------------------------------------------
  
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => JSON.stringify(_user['name']).toLowerCase().trim().indexOf(query.toLowerCase().trim()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
  }

const AgentAprroval = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState();
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [roleModalOpen, setRoleModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedRole, setSelectedRole] = useState('');
    const [roles, setRoles] = useState([]);
  
    async function GetList () {
      setLoading(true);
      const response = await GetAll(apiURL + '/api/v1/users/registration/get_user_by_pending');
           if(response) {
          if (response.data.status) {       
          setLoading(false);
          setList(response.data.data)
          }
          else {
          setLoading(false);
          toast.error(response.data.message)
            setList([])
          }
        }
        else {
          setLoading(false);
        }
  };

  async function GetRoles() {
    const response = await GetAll(apiURL + '/api/v1/users/getRoleByuser');
    if (response && response.data.status) {
      setRoles(response.data.data);
        }
  };
  
    useEffect(()=> {
      GetList();    
      GetRoles();    
    },[])
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = list.map((n) => n.exporter_company_Name);
        setSelected(newSelecteds);
        return;
      }
      setSelected([]);
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const handleFilterByName = (event) => {
      setFilterName(event.target.value);
    };
  
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list.length) : 0;
  
    const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName);
  
    const isUserNotFound = filteredUsers.length === 0;
    
    const handleApproveClick = (e, id) => {
      e.preventDefault();
      e.stopPropagation();
      setSelectedUserId(id);
      setRoleModalOpen(true);
    };

    const handleRoleModalClose = () => {
      setRoleModalOpen(false);
      setSelectedUserId(null);
      setSelectedRole('');
    };

    const handleApproveWithRole = async () => {
      if (!selectedRole) {
        toast.error('Please select a role before approving');
        return;
      }

      try {
        const response = await Post(apiURL + '/api/v1/users/registration/approve_user', { 
          id: selectedUserId, 
          role: selectedRole 
        });
        
        if (response && response.data.status) {
          toast.success('Agent approved successfully!');
          handleRoleModalClose();
          GetList();
        } else {
          toast.error(response?.data?.message || 'Failed to approve agent');
        }
      } catch (error) {
        console.error('Error approving agent:', error);
        toast.error('An error occurred while approving the agent');
      }
  };


    return (
        <Container sx={{m:0, width:'100%', maxWidth:'100%'}} maxWidth={false}>
        {/* Professional Header Section */}
        <Fade in timeout={800}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
              <Avatar sx={{ 
                bgcolor: '#1976d2', 
                width: 48, 
                height: 48,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
              }}>
                <PersonAddIcon sx={{ fontSize: 24, color: 'white' }} />
              </Avatar>
              <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Agent Approval
            </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Review and approve pending agent registrations
                </Typography>
              </Box>
        </Stack>
            <Divider sx={{ my: 2 }} />
          </Box>
        </Fade>

        <Zoom in timeout={1000}>
          <Card elevation={4} sx={{ 
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)'
          }}>
            {/* Enhanced Toolbar Section */}
            <Box sx={{ 
              p: 3, 
              backgroundColor: '#f8f9fa',
              borderBottom: '1px solid #e9ecef'
            }}>
              <UserListToolbar 
                placeholder="Search by Agent Name" 
                numSelected={selected.length} 
                filterName={filterName} 
                onFilterName={handleFilterByName} 
              />
            </Box>

          {/* <Scrollbar sx={undefined}> */}
            <TableContainer sx={{overflowX: 'auto'}}>
              <Table stickyHeader >
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={list?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckbox={false}
                />
                <TableBody>
                  {filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const { id, first_name, last_name, email, phone, emp_id, status } = row;
                    return (
                      <TableRow 
                        hover 
                        key={id} 
                        sx={{
                          cursor: 'pointer',
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            backgroundColor: '#f8f9fa',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                          }
                        }}
                      >
                        <TableCell component="th" scope="row" align="left" sx={{ fontWeight: 'bold' }}>
                          <Chip 
                            label={index + 1} 
                            size="small" 
                            sx={{ 
                              backgroundColor: '#1976d2',
                              color: 'white',
                              fontWeight: 'bold'
                            }} 
                          />
                        </TableCell>
                        <TableCell align="left" sx={{ color: '#1976d2', fontWeight: '600' }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <PersonAddIcon sx={{ fontSize: 16, color: '#1976d2' }} />
                            <Typography variant="body2" fontWeight="600">
                              {capitalCase(first_name + ' ' + last_name)}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <EmailIcon sx={{ fontSize: 16, color: '#6c757d' }} />
                            <Typography variant="body2" color="text.secondary">
                              {email}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <PhoneIcon sx={{ fontSize: 16, color: '#6c757d' }} />
                            <Typography variant="body2" color="text.secondary">
                              {phone}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <BadgeIcon sx={{ fontSize: 16, color: '#6c757d' }} />
                            <Typography variant="body2" color="text.secondary">
                              {emp_id}
                            </Typography>
                          </Stack>
                        </TableCell>
                        {status === 'PENDING' ? (
                          <TableCell align="center">
                            <Tooltip title="Approve Agent">
                              <Button
                                variant="contained"
                                onClick={(e) => handleApproveClick(e, id)}
                                sx={{
                                  backgroundColor: '#1976d2',
                                  '&:hover': {
                                    backgroundColor: '#1565c0'
                                  },
                                  borderRadius: 2,
                                  px: 2,
                                  py: 1,
                                  fontWeight: 'bold',
                                  textTransform: 'none'
                                }}
                                startIcon={<CheckCircleIcon />}
                              >
                                Approve
                              </Button>
                            </Tooltip>
                          </TableCell>
                        ) : (
                          <TableCell align="center">
                            <Chip
                              icon={<CheckCircleIcon />}
                              label="Approved"
                              color="success"
                              variant="filled"
                              sx={{ 
                                fontWeight: 'bold',
                                '& .MuiChip-label': { px: 2 }
                              }}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody> {loading ? <MiscSkeleton record={{number: 7}}/> :
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                       {list.length <=0 ? <Typography gutterBottom align="center" variant="subtitle1"> Not found</Typography> :<SearchNotFound searchQuery={filterName} /> }
                      </TableCell>
                    </TableRow> }
                  </TableBody> 
                )}
              </Table>
            </TableContainer>
          {/* </Scrollbar> */}

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: '1px solid #e9ecef',
                backgroundColor: '#f8f9fa'
              }}
          />
        </Card>
        </Zoom>

        {/* Enhanced Role Selection Modal */}
        <Modal open={roleModalOpen} onClose={handleRoleModalClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 450,
              bgcolor: 'background.paper',
              borderRadius: 3,
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
              p: 4,
              outline: 'none'
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
              <Avatar sx={{ bgcolor: '#1976d2', width: 40, height: 40 }}>
                <PersonAddIcon sx={{ fontSize: 20 }} />
              </Avatar>
              <Typography variant="h6" component="h2" fontWeight="bold">
                Select Role for Agent
              </Typography>
            </Stack>
            
            <FormControl fullWidth sx={{ mt: 2, mb: 3 }}>
              <InputLabel id="role-select-label">Role</InputLabel>
              <Select
                labelId="role-select-label"
                value={selectedRole}
                label="Role"
                onChange={(e) => setSelectedRole(e.target.value)}
                sx={{ borderRadius: 2 }}
              >
                {roles.map((role) => (
                  <MenuItem key={role.id} value={role.id ? roles.find((data) => data.id === role.id) : ''}>
                    {role.designation}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button 
                variant="outlined" 
                onClick={handleRoleModalClose}
                sx={{ 
                  borderRadius: 2,
                  px: 3,
                  py: 1.5
                }}
              >
                Cancel
              </Button>
              <Button 
                variant="contained" 
                onClick={handleApproveWithRole}
                disabled={!selectedRole}
                sx={{
                  backgroundColor: '#1976d2',
                  '&:hover': {
                    backgroundColor: '#1565c0'
                  },
                  borderRadius: 2,
                  px: 3,
                  py: 1.5,
                  fontWeight: 'bold'
                }}
                startIcon={<CheckCircleIcon />}
              >
                Approve Agent
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Professional Stats Footer */}
        <Fade in timeout={1200}>
          <Box sx={{ mt: 4 }}>
            <Paper elevation={2} sx={{ 
              p: 3, 
              borderRadius: 3,
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef'
            }}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: '#1976d2', 
                      width: 40, 
                      height: 40 
                    }}>
                      <PersonAddIcon sx={{ fontSize: 20 }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="text.primary">
                        {list.length}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Total Registrations
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: '#ff9800', 
                      width: 40, 
                      height: 40 
                    }}>
                      <PendingIcon sx={{ fontSize: 20 }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="text.primary">
                        {list.filter(item => item.status === 'PENDING').length}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Pending Approval
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: '#4caf50', 
                      width: 40, 
                      height: 40 
                    }}>
                      <CheckCircleIcon sx={{ fontSize: 20 }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="text.primary">
                        {list.filter(item => item.status === 'APPROVED').length}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Approved Agents
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Fade>
      </Container>
    )
}

export default AgentAprroval;